module.exports = __webpack_public_path__ + "img/db_czjl@2x.4660cac5.png";